// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"TabItem_tabItem__NBAXT","tabItemActive":"TabItem_tabItemActive__7MNmP"};